export type VideoType = 'movie' | 'tv' | 'variety';

export interface Episode {
  id: number;
  title: string;
  duration: string;
}

export interface Video {
  id: string;
  title: string;
  type: VideoType;
  cover: string;
  tagline: string;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  region: string;
  year: number;
  genres: string[];
  rating: number;
  views: number;
  favorites: number;
  updateDate: string;
  episodes: Episode[];
}

export interface HeroSlide {
  id: string;
  title: string;
  typeLabel: string;
  category: VideoType;
  tagline: string;
  backdrop: string;
}

export const TYPE_LABELS: Record<VideoType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};